import { createSlice } from '@reduxjs/toolkit';
import { asyncIsFulfilled, asyncIsPending, asyncIsRejected } from '../asyncConfig';
import {
  addAdmin, getAdminsFulfilled, getAdminLoginFulfilled, updateNotificationToken,
  getAllAdmins, passwordReset, userLogin, userLogout, updateAdminProfile, updateSocketID
} from './auth_thunk';

const initialState = {
  user: {},
  authState: '',
  admins: [],
  status: '',
  message: ''
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearAuthState: (state) => {
      state.authState = '';
      state.status = '';
      state.message = ''
    },
  },
  extraReducers: {
    [addAdmin.pending]: asyncIsPending,
    [addAdmin.rejected]: asyncIsRejected,
    [addAdmin.fulfilled]: asyncIsFulfilled,
    [getAllAdmins.pending]: asyncIsPending,
    [getAllAdmins.fulfilled]: getAdminsFulfilled,
    [getAllAdmins.rejected]: asyncIsRejected,
    [userLogin.pending]: asyncIsPending,
    [userLogin.rejected]: asyncIsRejected,
    [userLogin.fulfilled]: getAdminLoginFulfilled,
    [updateAdminProfile.pending]: asyncIsPending,
    [updateAdminProfile.rejected]: asyncIsRejected,
    [updateAdminProfile.fulfilled]: getAdminLoginFulfilled,
    [passwordReset.pending]: asyncIsPending,
    [passwordReset.rejected]: asyncIsRejected,
    [passwordReset.fulfilled]: asyncIsFulfilled,
    [userLogout.pending]: asyncIsPending,
    [userLogout.rejected]: asyncIsRejected,
    [userLogout.fulfilled]: asyncIsFulfilled,
    [updateNotificationToken.pending]: asyncIsPending,
    [updateNotificationToken.rejected]: asyncIsRejected,
    [updateNotificationToken.fulfilled]: asyncIsFulfilled,
    [updateSocketID.pending]: asyncIsPending,
    [updateSocketID.rejected]: asyncIsRejected,
    [updateSocketID.fulfilled]: asyncIsFulfilled,
  }
});

export const { clearAuthState } = authSlice.actions;
export default authSlice.reducer;